<div class="h-full flex flex-column bg-transparent overflow-hidden">

    <!-- PREMIUM HEADER - Glassmorphism al estilo de equipos -->
    <div class="glass-header flex flex-column md:flex-row align-items-start md:align-items-center gap-4 px-4 pt-4 mx-4 mt-4 mb-0">

        <!-- Left: Icon + Identity -->
        <div class="flex align-items-center gap-3 flex-grow-1">
            <p-button icon="pi pi-arrow-left" [text]="true" severity="secondary" (onClick)="back()" [rounded]="true" styleClass="p-button-lg" pTooltip="Volver"></p-button>

            <div class="item-visual"
                 style="width:64px;height:64px;border-radius:16px;display:flex;align-items:center;justify-content:center;flex-shrink:0;background:linear-gradient(135deg,#3b82f6 0%,#1e40af 100%);box-shadow:0 8px 15px -3px rgba(37,99,235,0.35)">
                <i [class]="getItemIcon()" style="color:white;font-size:1.8rem;"></i>
            </div>
            <div class="flex flex-column gap-1">
                <div class="flex align-items-center gap-2 flex-wrap">
                    <h1 class="text-2xl font-bold m-0 text-900 line-height-1">
                        {{ item()?.name || 'Nuevo Artículo' }}
                    </h1>
                    @if(item()?.id){
                        <span class="px-3 py-1 bg-indigo-100 text-indigo-700 border-round-xl text-sm font-bold border-1 border-indigo-200 flex align-items-center gap-1">
                            <i class="pi pi-tag text-xs"></i>{{ item()?.internal_code }}
                        </span>
                        <span class="px-2 py-1 text-xs border-round border-1" [ngClass]="getTypeClass()">
                            {{ translatedType }}
                        </span>
                    }
                </div>
                <div class="flex align-items-center gap-3 text-500 text-sm mt-1">
                    @if(item()?.brand?.name){
                        <span class="flex align-items-center gap-1"><i class="pi pi-bookmark text-primary"></i>{{ item()?.brand?.name }}</span>
                    }
                    @if(item()?.commercial_name){
                        <span class="flex align-items-center gap-1"><i class="pi pi-tag text-primary"></i>{{ item()?.commercial_name }}</span>
                    }
                    @if(item()?.form?.name){
                        <span class="flex align-items-center gap-1"><i class="pi pi-box text-primary"></i>{{ item()?.form?.name }}</span>
                    }
                    @if(!item()?.id){
                        <span class="text-500">Completá los datos para crear el artículo</span>
                    }
                </div>
            </div>
        </div>

        <!-- Right: Action Buttons -->
        <div class="flex gap-2 flex-shrink-0">
            @if(isTestItem() && item()?.id && massBalanceActive) {
                <p-button label="Balance de Masa" icon="pi pi-chart-pie" severity="info" (onClick)="viewMassBalance()" [rounded]="true" styleClass="p-button-sm mr-2"></p-button>
            }
            @if(item()?.id){
                <p-button label="Etiqueta" icon="pi pi-print" [outlined]="true" severity="secondary" (onClick)="printLabel()" [rounded]="true" styleClass="p-button-sm"></p-button>
            }
            @if(canManageInventory()){
                <p-button label="Guardar" icon="pi pi-check" severity="success" (onClick)="save()" [loading]="isSaving()" [disabled]="isSaving()" [rounded]="true" styleClass="p-button-sm"></p-button>
            }
        </div>
    </div>

    <!-- KPI QUICK STATS BAR -->
    @if(item()?.id && !isService()){
        <div class="grid mb-0 px-4 mt-3">
            @if(!isTestItem()){
                <div class="col-12 sm:col-6 md:col-3">
                    <div class="stat-mini-card" [ngClass]="getStockClass()">
                        <span class="stat-label">Stock Actual</span>
                        <span class="stat-value" [pTooltip]="'Total: ' + (item()?.stock || 0) + '\nReservado: ' + (item()?.reserved_stock || 0) + '\nBloqueado: ' + (item()?.blocked_stock || 0)">
                            <i class="pi pi-box mr-1"></i>Disp: {{ (item()?.stock || 0) - (item()?.reserved_stock || 0) - (item()?.blocked_stock || 0) }}
                            <span class="text-500 font-normal ml-1 text-sm"> / {{ item()?.stock ?? '0' }} {{ item()?.form?.name || 'und' }}</span>
                        </span>
                    </div>
                </div>
            }
            @if(canViewPrices()) {
                <div class="col-12 sm:col-6 md:col-3">
                    <div class="stat-mini-card">
                        <span class="stat-label">Precio Unitario</span>
                        <span class="stat-value text-700">
                            <i class="pi pi-dollar mr-1"></i>
                            {{ item()?.price ? (item()?.price | number:'1.2-2') + ' ' + (item()?.currency || 'USD') : 'No definido' }}
                        </span>
                    </div>
                </div>
            }
            <div class="col-12 sm:col-6 md:col-3">
                <div class="stat-mini-card" [ngClass]="getExpirationClass()">
                    <span class="stat-label">Vencimiento</span>
                    <span class="stat-value">
                        <i class="pi pi-calendar mr-1"></i>
                        {{ item()?.expiration_date ? (item()?.expiration_date | date:'dd/MM/yyyy') : 'Sin vencimiento' }}
                    </span>
                </div>
            </div>
            <div class="col-12 sm:col-6 md:col-3">
                <div class="stat-mini-card">
                    <span class="stat-label">Proveedor</span>
                    <span class="stat-value text-700">
                        <i class="pi pi-building mr-1"></i>{{ getMainSupplier() }}
                    </span>
                </div>
            </div>
        </div>
    }



    <!-- MAIN CONTENT -->

    <div class="flex-grow-1 overflow-hidden grid grid-nogutter h-full">

        <!-- LEFT COLUMN: MAIN FORM (TABS) -->
        <div class="col-12 lg:col-9 flex flex-column h-full border-right-1 border-200 bg-transparent overflow-hidden" style="min-width: 0;">
            <form [formGroup]="form" class="flex flex-column h-full overflow-hidden" style="min-width: 0;">
                <p-tabs [(value)]="activeTab" [scrollable]="true" class="flex flex-column h-full overflow-hidden" style="min-width: 0;">
                    <p-tablist class="bg-transparent px-3 pt-2" style="min-width: 0; max-width: 100%;" (wheel)="onTablistWheel($event)">
                        <p-tab [value]="99" *ngIf="mode() === 'create'"><i class="pi pi-tags mr-2"></i>Clasificación</p-tab>
                        <p-tab [value]="0">
                            <i class="pi pi-info-circle mr-2"></i>General
                            <i *ngIf="isTabInvalid(0)" class="pi pi-exclamation-circle text-red-500 text-xs ml-1" pTooltip="Contiene campos con errores" tooltipPosition="top"></i>
                        </p-tab>
                        <p-tab [value]="1" *ngIf="!isService() && !isTestItem()">
                            <i class="pi pi-box mr-2"></i>Inventario
                            <i *ngIf="isTabInvalid(1)" class="pi pi-exclamation-circle text-red-500 text-xs ml-1" pTooltip="Contiene campos con errores" tooltipPosition="top"></i>
                        </p-tab>
                        <p-tab [value]="10" *ngIf="item()?.id && !isService() && !isTestItem()"><i class="pi pi-database mr-2"></i>Lotes y Vencimientos</p-tab>
                        <p-tab [value]="12" *ngIf="item()?.id && isFractional()"><i class="pi pi-box mr-2"></i>Envases en Uso</p-tab>
                        <p-tab [value]="2"><i class="pi pi-shopping-cart mr-2"></i>Comercial</p-tab>
                        <p-tab [value]="7" *ngIf="!isService()"><i class="pi pi-file-edit mr-2"></i>Datos Técnicos</p-tab>
                        <p-tab [value]="8" *ngIf="isTestItem()">
                            <i class="pi pi-filter mr-2"></i>Datos de Item
                            <i *ngIf="isTabInvalid(8)" class="pi pi-exclamation-circle text-red-500 text-xs ml-1" pTooltip="Contiene campos con errores" tooltipPosition="top"></i>
                        </p-tab>
                        <p-tab [value]="4" *ngIf="item()?.id && !isService() && !isTestItem()"><i class="pi pi-history mr-2"></i>Movimientos</p-tab>
                        <p-tab [value]="11" *ngIf="item()?.id && !isService() && !isTestItem()"><i class="pi pi-book mr-2"></i>Consumos</p-tab>
                        <p-tab [value]="5" *ngIf="item()?.id"><i class="pi pi-file mr-2"></i>Archivos</p-tab>
                        <p-tab [value]="6" *ngIf="item()?.id && !isTestItem()"><i class="pi pi-link mr-2"></i>Vínculos</p-tab>
                    </p-tablist>

                    <p-tabpanels class="overflow-auto p-0 flex-grow-1 tab-scroll-area">
                        <!-- TAB 99: CLASIFICACION (Only on Create) -->
                        <p-tabpanel [value]="99" *ngIf="mode() === 'create'">
                            <div class="p-4 flex flex-column gap-4">
                                <div class="surface-card p-4 border-round shadow-1">
                                    <div class="section-header"><i class="pi pi-list"></i> Seleccione Tipo de Artículo</div>
                                    <div class="grid">
                                    @for(opt of itemTypes; track opt.value){
                                            <div class="col-12 md:col-4">
                                                <div class="premium-card-select p-3 border-round-xl border-1 cursor-pointer transition-all flex align-items-center gap-3"
                                                    [class.active]="form.get('type')?.value === opt.value"
                                                    (click)="form.get('type')?.setValue(opt.value)">
                                                    <div class="type-icon-circle"
                                                         [style.background]="form.get('type')?.value === opt.value ? '#2563eb' : '#e2e8f0'"
                                                         [style.boxShadow]="form.get('type')?.value === opt.value ? '0 4px 10px -2px rgba(37,99,235,0.45)' : 'none'"
                                                         style="width:3rem;height:3rem;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all 0.25s ease;">
                                                        <i [class]="opt.icon"
                                                           [style.color]="form.get('type')?.value === opt.value ? '#ffffff' : '#64748b'"
                                                           style="font-size:1.2rem;"></i>
                                                    </div>
                                                    <div class="flex flex-column">
                                                        <span class="font-bold text-sm" [class.text-primary]="form.get('type')?.value === opt.value">{{ opt.label }}</span>
                                                        <small class="text-500">{{ opt.description }}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- TAB 0: GENERAL -->
                        <p-tabpanel [value]="0">
                            <div class="p-4 flex flex-column gap-4">

                                <div class="surface-card p-4 border-round shadow-1">
                                    <div class="section-header"><i class="pi pi-id-card"></i> Identificación y Marca</div>
                                    <div class="grid">
                                        <div class="col-12 md:col-4">
                                            <label class="block font-medium mb-1">Nombre del Artículo <span class="text-red-500">*</span></label>
                                            <input pInputText formControlName="name" [placeholder]="placeholders().name" class="w-full" [class.p-invalid]="form.get('name')?.invalid && (form.get('name')?.dirty || form.get('name')?.touched)" />
                                            <small class="text-red-500 block mt-1" *ngIf="form.get('name')?.invalid && (form.get('name')?.dirty || form.get('name')?.touched)">
                                                <i class="pi pi-exclamation-circle mr-1"></i> El nombre es obligatorio (mínimo 3 caracteres).
                                            </small>
                                        </div>
                                        <div class="col-12 md:col-4">
                                            <label class="block font-medium mb-1">Nombre Comercial (Opcional)</label>
                                            <p-autoComplete formControlName="commercial_name" [suggestions]="commercialNamesFiltered()" (completeMethod)="searchCommercialName($event)" placeholder="Ej: Roundup, Galgo..." [dropdown]="true" class="w-full" styleClass="w-full" appendTo="body"></p-autoComplete>
                                        </div>
                                        <div class="col-12 md:col-4">
                                            <div class="flex align-items-center gap-1 mb-1">
                                                <label class="font-medium m-0">Código Interno <span class="text-red-500" *ngIf="!isTestItem()">*</span></label>
                                                <p-button *ngIf="isTestItem()"
                                                    icon="pi pi-info-circle"
                                                    [rounded]="true"
                                                    [text]="true"
                                                    severity="info"
                                                    pTooltip="¿Cómo se genera el código?"
                                                    (onClick)="codeInfoOp.toggle($event)"
                                                    styleClass="p-button-xs"
                                                    [style]="{'width': '1.5rem', 'height': '1.5rem', 'padding': '0'}">
                                                </p-button>
                                            </div>
                                            <input pInputText formControlName="internal_code" [placeholder]="placeholders().code" class="w-full" [class.p-invalid]="form.get('internal_code')?.invalid && (form.get('internal_code')?.dirty || form.get('internal_code')?.touched) && !isTestItem()" />
                                            <small class="text-red-500 block mt-1" *ngIf="form.get('internal_code')?.invalid && (form.get('internal_code')?.dirty || form.get('internal_code')?.touched) && !isTestItem()">
                                                <i class="pi pi-exclamation-circle mr-1"></i> El código interno es obligatorio.
                                            </small>
                                            <small class="text-500" *ngIf="isTestItem()"><i class="pi pi-refresh mr-1"></i>Se autogenera al guardar según la composición.</small>
                                        </div>

                                        <!-- Popover explicación código interno -->
                                        <p-popover #codeInfoOp [style]="{'max-width': '520px'}">
                                            <div class="p-4 flex flex-column gap-4">
                                                <div class="flex align-items-center gap-3 border-bottom-1 border-100 pb-3">
                                                    <div style="width:40px;height:40px;border-radius:10px;background:linear-gradient(135deg,#0d9488,#0f766e);display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                                                        <i class="pi pi-tag" style="color:white;font-size:1.2rem;"></i>
                                                    </div>
                                                    <div>
                                                        <h3 class="m-0 text-900 font-bold">Código Interno del Ítem de Ensayo</h3>
                                                        <p class="m-0 text-500 text-sm">Cómo el sistema construye el identificador único</p>
                                                    </div>
                                                </div>

                                                <p class="m-0 text-600 text-sm line-height-3">El código se construye <b>automáticamente al guardar</b>, concatenando los siguientes elementos:</p>

                                                <div class="flex flex-column gap-2">
                                                    <div class="flex align-items-center gap-2 p-2 bg-purple-50 border-round border-1 border-purple-200">
                                                        <span class="font-mono text-xs bg-purple-100 px-2 py-1 border-round text-purple-800 font-bold" style="min-width:4rem;text-align:center;">R</span>
                                                        <span class="text-sm text-600">La letra <b class="text-900">R</b> fija al inicio.</span>
                                                    </div>
                                                    <div class="flex align-items-center gap-2 p-2 bg-blue-50 border-round border-1 border-blue-200">
                                                        <span class="font-mono text-xs bg-blue-100 px-2 py-1 border-round text-blue-800 font-bold" style="min-width:4rem;text-align:center;">ABREV</span>
                                                        <span class="text-sm text-600"><b class="text-900">Abreviatura del principio activo</b> (del analito en composición). Ej: <code>GLP</code> para Glifosato</span>
                                                    </div>
                                                    <div class="flex align-items-center gap-2 p-2 bg-orange-50 border-round border-1 border-orange-200">
                                                        <span class="font-mono text-xs bg-orange-100 px-2 py-1 border-round text-orange-800 font-bold" style="min-width:4rem;text-align:center;">NN</span>
                                                        <span class="text-sm text-600"><b class="text-900">Número secuencial</b> (2 dígitos). Ej: <code>01</code>, <code>02</code>...</span>
                                                    </div>
                                                </div>

                                                <div class="bg-surface-100 p-3 border-round text-center border-1 border-200">
                                                    <span class="text-xs text-500 block mb-1">Ejemplo de código resultante:</span>
                                                    <span class="font-mono font-bold text-primary text-lg">RGLP-01</span>
                                                </div>

                                                <div class="flex align-items-start gap-2 p-2 bg-orange-50 border-round border-1 border-orange-200 mt-3">
                                                    <i class="pi pi-exclamation-triangle mt-1 text-orange-700 flex-shrink-0 text-sm"></i>
                                                    <p class="text-xs text-orange-700 m-0 line-height-3">
                                                        Si la composición de principios activos se modifica después de creado el ítem, el sistema solicita confirmación y <b>regenera el código</b>, invalidando el código anterior.
                                                    </p>
                                                </div>
                                            </div>
                                        </p-popover>
                                        @if(!isService() && !isTestItem()){
                                            <div class="col-12 md:col-6">
                                                <label class="block font-medium mb-1 text-primary">Marca <span class="text-red-500">*</span></label>
                                                <p-select [options]="brands()" formControlName="brandId" optionLabel="label" optionValue="value" placeholder="Seleccione Marca..." class="w-full" appendTo="body" [filter]="true" [ngClass]="{'ng-invalid ng-dirty': form.get('brandId')?.invalid && (form.get('brandId')?.dirty || form.get('brandId')?.touched)}"></p-select>
                                                <small class="text-red-500 block mt-1" *ngIf="form.get('brandId')?.invalid && (form.get('brandId')?.dirty || form.get('brandId')?.touched)">
                                                    <i class="pi pi-exclamation-circle mr-1"></i> La marca es obligatoria.
                                                </small>
                                            </div>
                                            <div class="col-12 md:col-6">
                                                <label class="block font-medium mb-1 text-primary">Forma / Presentación <span class="text-red-500">*</span></label>
                                                <p-select [options]="forms()" formControlName="formId" optionLabel="label" optionValue="value" placeholder="Ej: Bidón 5L, Frasco..." class="w-full" appendTo="body" [filter]="true" [ngClass]="{'ng-invalid ng-dirty': form.get('formId')?.invalid && (form.get('formId')?.dirty || form.get('formId')?.touched)}"></p-select>
                                                <small class="text-red-500 block mt-1" *ngIf="form.get('formId')?.invalid && (form.get('formId')?.dirty || form.get('formId')?.touched)">
                                                    <i class="pi pi-exclamation-circle mr-1"></i> La forma / presentación es obligatoria.
                                                </small>
                                            </div>
                                            <div class="col-12 md:col-6">
                                                <label class="block font-medium mb-1 text-primary">Ubicación</label>
                                                <p-select [options]="locations()" formControlName="locationId" optionLabel="name" optionValue="id" placeholder="Depósito / Estante..." class="w-full" appendTo="body" [filter]="true" [showClear]="true"></p-select>
                                            </div>
                                            <div class="col-12 md:col-6">
                                                <label class="block font-medium mb-1 text-primary">Matriz Asociada (LIMS)</label>
                                                <p-select [options]="matrixOptions()" formControlName="matrixId" optionLabel="label" optionValue="value" placeholder="Seleccione Matriz (opcional)..." class="w-full" appendTo="body" [filter]="true" [showClear]="true"></p-select>
                                            </div>
                                        } @else if(!isService()) {
                                            <div class="col-12 md:col-6">
                                                <label class="block font-medium mb-1 text-primary">Ubicación</label>
                                                <p-select [options]="locations()" formControlName="locationId" optionLabel="name" optionValue="id" placeholder="Depósito / Estante..." class="w-full" appendTo="body" [filter]="true" [showClear]="true"></p-select>
                                            </div>
                                            <div class="col-12 md:col-6">
                                                <label class="block font-medium mb-1 text-primary">Matriz Asociada (LIMS)</label>
                                                <p-select [options]="matrixOptions()" formControlName="matrixId" optionLabel="label" optionValue="value" placeholder="Seleccione Matriz (opcional)..." class="w-full" appendTo="body" [filter]="true" [showClear]="true"></p-select>
                                            </div>
                                        }
                                        <div class="col-12">
                                            <label class="block font-medium mb-1">Etiquetas</label>
                                            <p-chips formControlName="tags" styleClass="w-full" inputStyleClass="w-full" placeholder="Presione enter para agregar"></p-chips>
                                        </div>
                                    </div>
                                </div>

                                <div class="surface-card p-4 border-round shadow-1">
                                    <div class="section-header"><i class="pi pi-align-left"></i> Descripción</div>
                                    <textarea pInputTextarea formControlName="description" rows="4" class="w-full" [placeholder]="placeholders().description"></textarea>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- Rest of TABS (Inventory, Commercial, etc.) - Content skipped for brevity but would be here -->
                        <p-tabpanel [value]="1" *ngIf="!isService() && !isTestItem()">
                            <div class="p-4 flex flex-column gap-4">
                                <div class="surface-card p-4 border-round shadow-1">
                                    <div class="section-header"><i class="pi pi-box"></i> Control de Existencias</div>
                                    <div class="grid">
                                        <div class="col-12 md:col-6">
                                            <label class="block font-medium mb-1">Código de Barras / QR</label>
                                            <p-inputgroup>
                                                <p-inputgroup-addon><i class="pi pi-barcode"></i></p-inputgroup-addon>
                                                <input pInputText formControlName="barcode" placeholder="Escanee o ingrese el código" class="w-full" />
                                            </p-inputgroup>
                                        </div>
                                        <div class="col-12 md:col-6">
                                            <div class="flex justify-content-between align-items-center mb-1">
                                                <label class="font-medium text-primary font-bold">Stock Actual <span class="text-red-500">*</span></label>
                                                @if(mode() !== 'create' && item()?.id){
                                                    <span class="text-xs text-500 font-medium">Calculado por lotes/movimientos</span>
                                                }
                                            </div>
                                            @if(mode() === 'create'){
                                                <p-inputNumber formControlName="stock" [min]="0" class="w-full" styleClass="w-full" [showButtons]="true" buttonLayout="horizontal" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" [ngClass]="{'ng-invalid ng-dirty': form.get('stock')?.invalid && (form.get('stock')?.dirty || form.get('stock')?.touched)}"></p-inputNumber>
                                                <small class="text-red-500 block mt-1" *ngIf="form.get('stock')?.invalid && (form.get('stock')?.dirty || form.get('stock')?.touched)">
                                                    <i class="pi pi-exclamation-circle mr-1"></i> El stock inicial es obligatorio (mínimo 0).
                                                </small>
                                                <small class="text-500 block mt-1" *ngIf="!form.get('stock')?.invalid || (!form.get('stock')?.dirty && !form.get('stock')?.touched)">Stock inicial con el que se dará de alta el artículo.</small>
                                            } @else {
                                                <div class="p-inputgroup">
                                                    <p-inputNumber formControlName="stock" [disabled]="true" class="w-full" styleClass="w-full"></p-inputNumber>
                                                    <button type="button" pButton icon="pi pi-database" label="Ver Lotes" class="p-button-outlined" (click)="activeTab.set(10)" pTooltip="Gestionar lotes y vencimientos"></button>
                                                </div>
                                                <div class="mt-2 p-2 border-round bg-blue-50 border-1 border-blue-200 flex align-items-center gap-2">
                                                    <i class="pi pi-info-circle text-blue-600 text-sm"></i>
                                                    <small class="text-blue-900 line-height-2">
                                                        El stock actual es el resultado de la sumatoria de todos los lotes activos. Para modificar existencias, registre un <strong>movimiento de stock</strong> o gestione los lotes en la pestaña <strong>"Lotes y Vencimientos"</strong>.
                                                    </small>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <p-divider align="center" class="my-4"><span class="text-500 font-medium">Límites de Inventario</span></p-divider>

                                    <div class="grid">
                                        <div class="col-12 md:col-4">
                                            <label class="block font-medium mb-1 text-red-600 font-bold">Stock Mínimo</label>
                                            <p-inputNumber formControlName="min_stock" [min]="0" class="w-full" styleClass="w-full" [ngClass]="{'ng-invalid ng-dirty': form.get('min_stock')?.invalid && (form.get('min_stock')?.dirty || form.get('min_stock')?.touched)}"></p-inputNumber>
                                            <small class="text-red-500 block mt-1" *ngIf="form.get('min_stock')?.invalid && (form.get('min_stock')?.dirty || form.get('min_stock')?.touched)">
                                                <i class="pi pi-exclamation-circle mr-1"></i> Debe ser mayor o igual a 0.
                                            </small>
                                        </div>
                                        <div class="col-12 md:col-4">
                                            <label class="block font-medium mb-1 text-orange-600 font-bold">Stock Alerta</label>
                                            <p-inputNumber formControlName="alert_stock" [min]="0" class="w-full" styleClass="w-full" [ngClass]="{'ng-invalid ng-dirty': form.get('alert_stock')?.invalid && (form.get('alert_stock')?.dirty || form.get('alert_stock')?.touched)}"></p-inputNumber>
                                            <small class="text-red-500 block mt-1" *ngIf="form.get('alert_stock')?.invalid && (form.get('alert_stock')?.dirty || form.get('alert_stock')?.touched)">
                                                <i class="pi pi-exclamation-circle mr-1"></i> Debe ser mayor o igual a 0.
                                            </small>
                                        </div>
                                        <div class="col-12 md:col-4">
                                            <label class="block font-medium mb-1 text-blue-600 font-bold">Stock Máximo</label>
                                            <p-inputNumber formControlName="max_stock" [min]="0" class="w-full" styleClass="w-full" [ngClass]="{'ng-invalid ng-dirty': form.get('max_stock')?.invalid && (form.get('max_stock')?.dirty || form.get('max_stock')?.touched)}"></p-inputNumber>
                                            <small class="text-red-500 block mt-1" *ngIf="form.get('max_stock')?.invalid && (form.get('max_stock')?.dirty || form.get('max_stock')?.touched)">
                                                <i class="pi pi-exclamation-circle mr-1"></i> Debe ser mayor o igual a 0.
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <!-- Modo de Consumo y Fraccionamiento -->
                                <div class="surface-card p-4 border-round shadow-1" *ngIf="isConsumable() || isReactive() || isStandard()">
                                    <div class="section-header"><i class="pi pi-box"></i> Modo de Consumo y Fraccionamiento</div>
                                    <div class="grid">
                                        <div class="col-12 md:col-6">
                                            <label class="block font-medium mb-1">Modo de Consumo del Artículo</label>
                                            <p-select [options]="consumptionModes" formControlName="consumption_mode" optionLabel="label" optionValue="value" placeholder="Seleccione modo..." class="w-full" appendTo="body"></p-select>
                                            <small class="text-500 block mt-1">
                                                @if(form.get('consumption_mode')?.value === 'FRACTIONAL'){
                                                    El artículo ingresa en envases pero se consume de forma fraccional (alícuotas) en laboratorio.
                                                } @else {
                                                    El artículo se consume por unidad/envase completo en almacén.
                                                }
                                            </small>
                                        </div>
                                        <div class="col-12 md:col-6" *ngIf="form.get('consumption_mode')?.value === 'FRACTIONAL'">
                                            <label class="block font-medium mb-1">Días de Estabilidad tras Apertura (En Uso)</label>
                                            <p-inputNumber formControlName="in_use_stability_days" class="w-full" [min]="0" placeholder="Ej: 90 (días)"></p-inputNumber>
                                            <small class="text-500 block mt-1">Plazo de caducidad una vez abierto el envase (opcional).</small>
                                        </div>
                                        <div class="col-12 md:col-6" *ngIf="form.get('consumption_mode')?.value === 'FRACTIONAL'">
                                            <label class="block font-medium mb-1">Contenido Nominal por Envase</label>
                                            <p-inputNumber formControlName="nominal_content" class="w-full" [min]="0" [minFractionDigits]="1" [maxFractionDigits]="4" placeholder="Ej: 100"></p-inputNumber>
                                            <small class="text-500 block mt-1">Masa o volumen inicial contenido en cada envase.</small>
                                        </div>
                                        <div class="col-12 md:col-6" *ngIf="form.get('consumption_mode')?.value === 'FRACTIONAL'">
                                            <label class="block font-medium mb-1">Unidad de Contenido</label>
                                            <p-select [options]="contentUnitOptions()"
                                                      formControlName="content_unit"
                                                      optionLabel="label"
                                                      optionValue="value"
                                                      [filter]="true"
                                                      [showClear]="true"
                                                      placeholder="Seleccione unidad de medida..."
                                                      class="w-full"
                                                      appendTo="body"></p-select>
                                            <small class="text-500 block mt-1">Unidad tabulada de la tabla maestra de unidades (mg, mL, g, etc.).</small>
                                        </div>
                                        <div class="col-12 md:col-6" *ngIf="form.get('consumption_mode')?.value === 'FRACTIONAL'">
                                            <label class="block font-medium mb-1">Modo de Identificación de Recipientes</label>
                                            <p-select [options]="containerNumberingModes"
                                                      formControlName="container_numbering_mode"
                                                      optionLabel="label"
                                                      optionValue="value"
                                                      placeholder="Seleccione modo..."
                                                      class="w-full"
                                                      appendTo="body"></p-select>
                                            <small class="text-500 block mt-1">Regla de numeración para frascos individuales del lote.</small>
                                        </div>
                                        <div class="col-12 md:col-6" *ngIf="form.get('consumption_mode')?.value === 'FRACTIONAL'">
                                            <label class="block font-medium mb-1">Prefijo de Frasco / Envase</label>
                                            <input pInputText formControlName="container_prefix" placeholder="Ej: PAT, STD, REA" class="w-full" />
                                            <small class="text-500 block mt-1">Prefijo unívoco para rotulado (ej: PAT -> PAT-0001).</small>
                                        </div>
                                        <div class="col-12 md:col-6" *ngIf="form.get('consumption_mode')?.value === 'FRACTIONAL'">
                                            <label class="block font-medium mb-1">Punto de Pedido por Contenido (%)</label>
                                            <p-inputNumber formControlName="reorder_content_threshold_percent" class="w-full" [min]="1" [max]="100" suffix="%" placeholder="20%"
                                                          [ngClass]="{'ng-invalid ng-dirty': form.get('reorder_content_threshold_percent')?.invalid && (form.get('reorder_content_threshold_percent')?.dirty || form.get('reorder_content_threshold_percent')?.touched)}"></p-inputNumber>
                                            <small class="text-500 block mt-1" *ngIf="!form.get('reorder_content_threshold_percent')?.invalid || (!form.get('reorder_content_threshold_percent')?.dirty && !form.get('reorder_content_threshold_percent')?.touched)">
                                                Alarma de compra cuando el último envase caiga a este % o menos (default: 20%).
                                            </small>
                                            <small class="text-red-500 block mt-1" *ngIf="form.get('reorder_content_threshold_percent')?.invalid && (form.get('reorder_content_threshold_percent')?.dirty || form.get('reorder_content_threshold_percent')?.touched)">
                                                El umbral de contenido debe ser un valor entre 1% y 100%.
                                            </small>
                                        </div>
                                        <div class="col-12 md:col-6" *ngIf="form.get('consumption_mode')?.value === 'FRACTIONAL'">
                                            <label class="block font-medium mb-1">Punto de Pedido por Vigencia (%)</label>
                                            <p-inputNumber formControlName="reorder_stability_percent" class="w-full" [min]="1" [max]="100" suffix="%" placeholder="80%"
                                                          [ngClass]="{'ng-invalid ng-dirty': form.get('reorder_stability_percent')?.invalid && (form.get('reorder_stability_percent')?.dirty || form.get('reorder_stability_percent')?.touched)}"></p-inputNumber>
                                            <small class="text-500 block mt-1" *ngIf="!form.get('reorder_stability_percent')?.invalid || !form.get('reorder_stability_percent')?.touched">
                                                Alarma cuando el envase activo transcurra este % de su vida útil (default: 80%).
                                            </small>
                                            <small class="text-red-500 block mt-1" *ngIf="form.get('reorder_stability_percent')?.invalid && form.get('reorder_stability_percent')?.touched">
                                                El umbral de vigencia debe ser un valor entre 1% y 100%.
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <!-- Control de Calidad y Cuarentena de Lotes -->
                                <div class="surface-card p-4 border-round shadow-1 mt-3" *ngIf="!isService() && !isTestItem()">
                                    <div class="section-header"><i class="pi pi-verified"></i> Control de Calidad y Cuarentena de Lotes</div>
                                    <div class="flex align-items-center justify-content-between p-3 border-round surface-50 border-1 surface-border">
                                        <div class="flex flex-column gap-1 mr-3">
                                            <label class="font-bold text-900 m-0">Requiere Control de Calidad / Liberación</label>
                                            <span class="text-sm text-600">
                                                Al estar activo, todo nuevo lote ingresará automáticamente en estado <strong>En Cuarentena (Bloqueado)</strong>. Almacén y laboratorio no podrán realizar egresos ni consumos hasta su liberación formal desde el Quality Hub.
                                            </span>
                                        </div>
                                        <p-toggleswitch formControlName="requires_analysis"></p-toggleswitch>
                                    </div>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- TAB 10: LOTES Y VENCIMIENTOS (FEFO / FIFO) -->
                        <p-tabpanel [value]="10" *ngIf="item()?.id && !isService() && !isTestItem()">
                            <div class="p-4 flex flex-column gap-4">
                                <!-- Strategy Callout Banner -->
                                <div class="surface-card p-4 border-round-xl border-1 shadow-1 flex flex-column md:flex-row align-items-start md:align-items-center justify-content-between gap-3"
                                     [style.borderLeft]="consumptionStrategy() === 'FEFO' ? '5px solid #2563eb' : '5px solid #0d9488'"
                                     [style.background]="consumptionStrategy() === 'FEFO' ? '#eff6ff' : '#f0fdfa'">
                                    <div class="flex align-items-center gap-3">
                                        <div class="border-circle p-3 flex align-items-center justify-content-center text-white"
                                             [style.background]="consumptionStrategy() === 'FEFO' ? '#2563eb' : '#0d9488'">
                                            <i [class]="consumptionStrategy() === 'FEFO' ? 'pi pi-calendar-clock text-xl' : 'pi pi-sort-amount-down text-xl'"></i>
                                        </div>
                                        <div>
                                            <div class="flex align-items-center gap-2 mb-1">
                                                <span class="font-bold text-900 text-lg">Criterio de Consumo: {{ consumptionStrategy() === 'FEFO' ? 'FEFO (Primero en Vencer, Primero en Salir)' : 'FIFO (Primero en Entrar, Primero en Salir)' }}</span>
                                                <p-tag [value]="consumptionStrategy()" [severity]="consumptionStrategy() === 'FEFO' ? 'info' : 'success'"></p-tag>
                                            </div>
                                            <p class="m-0 text-sm text-700">
                                                @if(consumptionStrategy() === 'FEFO'){
                                                    Para este artículo perecedero, el sistema <strong>recomienda automáticamente consumir el lote con fecha de expiración más próxima</strong> para minimizar descartes y mermas de reactivos.
                                                } @else {
                                                    Este artículo no posee fechas de vencimiento registradas. El sistema <strong>recomienda consumir el lote más antiguo</strong> según su fecha de ingreso/recepción al almacén.
                                                }
                                            </p>
                                        </div>
                                    </div>
                                    @if(canManageInventory()){
                                        <p-button label="Ingresar Lote" icon="pi pi-arrow-down-left" severity="primary" (onClick)="goToStockMovementIn()" styleClass="p-button-sm" pTooltip="Registrar recepción / ingreso de lote vía movimiento"></p-button>
                                    }
                                </div>

                                <!-- Lots Table -->
                                <div class="surface-card p-3 border-round-xl shadow-1">
                                    <p-table [value]="itemLots()" [loading]="loadingLots()" responsiveLayout="scroll" styleClass="p-datatable-sm">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>Nº de Lote</th>
                                                <th>Control Interno</th>
                                                <th>Vencimiento</th>
                                                <th>Días Restantes</th>
                                                <th>Fecha Ingreso</th>
                                                <th class="text-right">Stock Lote</th>
                                                <th class="text-right">Reservado</th>
                                                <th class="text-right font-bold text-primary">Disponible</th>
                                                <th>Ubicación</th>
                                                @if(canViewPrices()){
                                                    <th class="text-right">Costo Unit.</th>
                                                }
                                                <th>Estado</th>
                                                <th class="text-center" style="width: 140px;">Acciones</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-lot>
                                            <tr>
                                                <td>
                                                    <div class="flex align-items-center gap-2">
                                                        <a class="font-bold text-primary cursor-pointer hover:underline"
                                                           (click)="goToLotQuality(lot)"
                                                           [pTooltip]="'Ver Calidad y Liberación del Lote ' + lot.lot_number"
                                                           tooltipPosition="top">
                                                            {{ lot.lot_number }}
                                                        </a>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span class="font-medium text-700" *ngIf="lot.internal_lot_code">{{ lot.internal_lot_code }}</span>
                                                    <span class="text-400 italic" *ngIf="!lot.internal_lot_code">-</span>
                                                </td>
                                                <td>
                                                    @if(lot.expiration_date){
                                                        <span>{{ lot.expiration_date | date:'dd/MM/yyyy' }}</span>
                                                    } @else {
                                                        <span class="text-400 italic">Sin vencimiento</span>
                                                    }
                                                </td>
                                                <td>
                                                    @if(lot.expiration_date){
                                                        @let days = getDaysUntilExpiration(lot.expiration_date);
                                                        @if(days !== null && days < 0){
                                                             <p-tag value="Vencido" severity="danger"></p-tag>
                                                        } @else if(days !== null && days <= 30){
                                                             <p-tag [value]="days + ' días'" severity="warn"></p-tag>
                                                        } @else if(days !== null){
                                                             <span class="text-600 font-medium">{{ days }} días</span>
                                                        }
                                                    } @else {
                                                        <span class="text-400">-</span>
                                                    }
                                                </td>
                                                <td>{{ lot.reception_date ? (lot.reception_date | date:'dd/MM/yyyy') : (lot.createdAt | date:'dd/MM/yyyy') }}</td>
                                                <td class="text-right font-bold">{{ lot.current_quantity }}</td>
                                                <td class="text-right text-orange-600">{{ lot.reserved_quantity || 0 }}</td>
                                                <td class="text-right font-bold text-green-600">
                                                    {{ (lot.current_quantity || 0) - (lot.reserved_quantity || 0) - (lot.blocked_quantity || 0) }}
                                                </td>
                                                <td>{{ lot.location?.name || 'Depósito General' }}</td>
                                                @if(canViewPrices()){
                                                    <td class="text-right">{{ lot.unit_price ? (lot.unit_price | currency:(lot.currency || 'ARS'):'symbol-narrow') : '-' }}</td>
                                                }
                                                <td>
                                                    @if(lot.status === 'ACTIVE'){
                                                        <p-tag value="Activo" severity="success"></p-tag>
                                                    } @else if(lot.status === 'DEPLETED'){
                                                        <p-tag value="Agotado" severity="secondary"></p-tag>
                                                    } @else if(lot.status === 'EXPIRED'){
                                                        <p-tag value="Vencido" severity="danger"></p-tag>
                                                    } @else if(lot.status === 'BLOCKED'){
                                                        <p-tag value="Bloqueado" severity="warn"></p-tag>
                                                    }
                                                </td>
                                                <td class="text-center">
                                                    <div class="flex align-items-center justify-content-center gap-1">
                                                        <p-button icon="pi pi-verified"
                                                                  [text]="true"
                                                                  [rounded]="true"
                                                                  size="small"
                                                                  severity="help"
                                                                  (onClick)="goToLotQuality(lot)"
                                                                  pTooltip="Calidad y Liberación de Lote"
                                                                  tooltipPosition="bottom">
                                                        </p-button>
                                                        @if(canManageInventory()){
                                                            <p-button icon="pi pi-pencil" [text]="true" [rounded]="true" size="small" (onClick)="openEditLotDialog(lot)" pTooltip="Editar Lote"></p-button>
                                                            <p-button icon="pi pi-trash" [text]="true" [rounded]="true" size="small" severity="danger" (onClick)="deleteLot(lot)" pTooltip="Eliminar Lote"></p-button>
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td [attr.colspan]="canViewPrices() ? 11 : 10" class="text-center py-5 text-500">
                                                    <i class="pi pi-database text-3xl text-400 mb-2 block"></i>
                                                    No hay lotes registrados para este artículo. Puede dar de alta el primer lote con el botón superior.
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- TAB 12: ENVASES EN USO (FRACCIONAL) -->
                        <p-tabpanel [value]="12" *ngIf="item()?.id && isFractional()">
                            <div class="p-4 flex flex-column gap-4">
                                <!-- Banner informativo de consumo fraccional -->
                                <div class="surface-card p-4 border-round-xl border-1 shadow-1 flex flex-column md:flex-row align-items-start md:align-items-center justify-content-between gap-3"
                                     style="border-left: 5px solid #6366f1; background: #f5f3ff;">
                                    <div class="flex align-items-center gap-3">
                                        <div class="border-circle p-3 flex align-items-center justify-content-center text-white"
                                             style="background: #6366f1;">
                                            <i class="pi pi-box text-xl"></i>
                                        </div>
                                        <div>
                                            <div class="flex align-items-center gap-2 mb-1">
                                                <span class="font-bold text-900 text-lg">Control de Envases en Fraccionamiento y Estabilidad</span>
                                                <p-tag value="Fraccional" severity="help"></p-tag>
                                            </div>
                                            <p class="m-0 text-sm text-700">
                                                Este artículo se consume por alícuotas o fracciones. Cada envase posee una capacidad nominal de
                                                <strong>{{ form.get('nominal_content')?.value || item()?.nominal_content || '-' }} {{ form.get('content_unit')?.value || item()?.content_unit || '' }}</strong>.
                                                Al abrir un envase sellado, se computa su período de estabilidad en uso
                                                (<strong>{{ form.get('in_use_stability_days')?.value || item()?.in_use_stability_days || 'N/A' }} días</strong>)
                                                y se habilita el descuento directo de masa o volumen.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex align-items-center gap-2">
                                        <p-button label="Ver Lotes"
                                                  icon="pi pi-database"
                                                  [outlined]="true"
                                                  severity="secondary"
                                                  size="small"
                                                  (onClick)="activeTab.set(10)"
                                                  pTooltip="Ir a pestaña de lotes para consultar recepciones y altas">
                                        </p-button>
                                    </div>
                                </div>

                                <!-- Containers Table -->
                                <div class="surface-card p-3 border-round-xl shadow-1">
                                    <div class="flex align-items-center justify-content-between mb-3 px-2">
                                        <div>
                                            <span class="font-bold text-900 text-base">Envases Individualizados</span>
                                            <span class="text-xs text-500 block">Listado de frascos y unidades registradas en los lotes activos.</span>
                                        </div>
                                        <p-button icon="pi pi-refresh"
                                                  [text]="true"
                                                  [rounded]="true"
                                                  size="small"
                                                  severity="secondary"
                                                  (onClick)="loadItemLots()"
                                                  [loading]="loadingContainers()"
                                                  pTooltip="Actualizar envases">
                                        </p-button>
                                    </div>

                                    <p-table [value]="containers()" [loading]="loadingContainers()" responsiveLayout="scroll" styleClass="p-datatable-sm">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>Código de Envase</th>
                                                <th>Lote</th>
                                                <th>Estado</th>
                                                <th>Apertura</th>
                                                <th>Vencimiento en Uso</th>
                                                <th>Ubicación</th>
                                                <th style="width: 14rem;">Contenido Remanente</th>
                                                <th class="text-center" style="width: 150px;">Acciones</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-container>
                                            <tr>
                                                <td>
                                                    <div class="flex align-items-center gap-2">
                                                        <i class="pi pi-box text-primary text-sm"></i>
                                                        <strong class="text-primary font-bold">{{ container.container_code }}</strong>
                                                    </div>
                                                </td>
                                                <td>
                                                    <a class="font-semibold text-primary cursor-pointer hover:underline text-sm"
                                                       (click)="goToLotQualityForContainer(container)"
                                                       [pTooltip]="'Ver Calidad y Liberación del Lote ' + container.lot_number">
                                                        {{ container.lot_number || '-' }}
                                                    </a>
                                                </td>
                                                <td>
                                                    <p-tag [value]="getContainerStatusLabel(container.status)"
                                                           [severity]="getContainerStatusSeverity(container.status)">
                                                    </p-tag>
                                                </td>
                                                <td>
                                                    <span class="text-xs text-700">
                                                        {{ container.opened_at ? (container.opened_at | date:'dd/MM/yyyy HH:mm') : '-' }}
                                                        @if (container.opened_by) {
                                                            <small class="text-500 block">por {{ container.opened_by }}</small>
                                                        }
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="text-xs font-semibold"
                                                          [ngClass]="{'text-red-600 font-bold': container.in_use_expiration_date && getDaysUntilExpiration(container.in_use_expiration_date) !== null && getDaysUntilExpiration(container.in_use_expiration_date)! < 0}">
                                                        {{ container.in_use_expiration_date ? (container.in_use_expiration_date | date:'dd/MM/yyyy') : '-' }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="text-xs text-600">{{ container.storage_location || '-' }}</span>
                                                </td>
                                                <td>
                                                    <div class="flex flex-column gap-1">
                                                        <div class="flex align-items-center justify-content-between text-xs">
                                                            <span class="font-bold text-900">{{ container.remaining_content }} {{ container.content_unit || form.get('content_unit')?.value }}</span>
                                                            <span class="text-500">de {{ container.initial_content || container.nominal_content }} {{ container.content_unit || form.get('content_unit')?.value }} ({{ getContainerProgress(container) }}%)</span>
                                                        </div>
                                                        <p-progressBar [value]="getContainerProgress(container)" [showValue]="false" [style]="{ height: '6px' }"></p-progressBar>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <div class="flex align-items-center justify-content-center gap-1">
                                                        @if (container.status === 'SEALED') {
                                                            <p-button label="Abrir"
                                                                      icon="pi pi-box"
                                                                      size="small"
                                                                      severity="info"
                                                                      [outlined]="true"
                                                                      (onClick)="openContainer(container)"
                                                                      pTooltip="Registrar la apertura del envase e iniciar estabilidad en uso">
                                                            </p-button>
                                                        } @else if (container.status === 'OPEN') {
                                                            <p-button label="Consumir"
                                                                      icon="pi pi-minus-circle"
                                                                      size="small"
                                                                      severity="warn"
                                                                      (onClick)="openConsumeDialog(container)"
                                                                      pTooltip="Registrar extracción o consumo de alícuota">
                                                            </p-button>
                                                            <p-button icon="pi pi-trash"
                                                                      size="small"
                                                                      severity="danger"
                                                                      [text]="true"
                                                                      [rounded]="true"
                                                                      (onClick)="discardContainer(container)"
                                                                      pTooltip="Descartar envase remanente">
                                                            </p-button>
                                                        }
                                                        <p-button icon="pi pi-history"
                                                                  size="small"
                                                                  severity="secondary"
                                                                  [text]="true"
                                                                  [rounded]="true"
                                                                  (onClick)="openContainerConsumptions(container)"
                                                                  pTooltip="Ver historial de consumos del envase">
                                                        </p-button>
                                                        <p-button icon="pi pi-verified"
                                                                  size="small"
                                                                  severity="help"
                                                                  [text]="true"
                                                                  [rounded]="true"
                                                                  (onClick)="goToLotQualityForContainer(container)"
                                                                  pTooltip="Calidad y Liberación de Lote">
                                                        </p-button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="8" class="text-center py-5 text-500">
                                                    <i class="pi pi-box text-3xl text-400 mb-2 block"></i>
                                                    <span class="font-bold text-base text-900 block mb-1">No hay envases registrados para los lotes de este artículo.</span>
                                                    <span class="text-xs text-600 block mb-3">
                                                        Los envases fraccionales se generan individualmente o por lote en la vista de Calidad y Liberación de Lote.
                                                    </span>
                                                    <p-button label="Ir a Lotes y Vencimientos"
                                                              icon="pi pi-database"
                                                              size="small"
                                                              severity="primary"
                                                              (onClick)="activeTab.set(10)">
                                                    </p-button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- TAB COMMERCIAL -->
                        <p-tabpanel [value]="2">
                            <div class="p-4">
                                <div class="surface-card p-4 border-round shadow-1">
                                    <div class="section-header"><i class="pi pi-shopping-cart"></i> Proveedores y Costos</div>
                                    <div class="grid">
                                        <div class="col-12">
                                            <label class="block font-medium mb-1 text-primary">Proveedor Principal</label>
                                            <p-select [options]="suppliers()" formControlName="supplierId" optionLabel="label" optionValue="value" placeholder="Seleccione Proveedor..." class="w-full" [filter]="true" appendTo="body"></p-select>
                                        </div>
                                        @if(canViewPrices()) {
                                            <div class="col-12 md:col-6 mt-3">
                                                <label class="block font-medium mb-1">Precio Unitario</label>
                                                <p-inputNumber formControlName="price" mode="currency" [currency]="form.get('currency')?.value || 'USD'" locale="en-US" class="w-full" styleClass="w-full"></p-inputNumber>
                                            </div>
                                            <div class="col-12 md:col-6 mt-3">
                                                <label class="block font-medium mb-1">Moneda</label>
                                                <p-select [options]="currencies" formControlName="currency" optionLabel="label" optionValue="value" class="w-full" appendTo="body"></p-select>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- TAB TECHNICAL -->
                        <p-tabpanel [value]="7" *ngIf="!isService()">
                            <div class="p-4 flex flex-column gap-4">
                                <div class="surface-card p-4 border-round shadow-1" *ngIf="isConsumable() || isTestItem() || isReactive()">
                                    <div class="section-header"><i class="pi pi-calendar"></i> Trazabilidad y Fechas</div>
                                    <div class="grid">
                                        <div class="col-12 md:col-6 lg:col-3">
                                            <label class="block font-medium mb-1">Nº Lote</label>
                                            <input pInputText formControlName="lot_number" class="w-full" placeholder="Lote del fabricante" />
                                        </div>
                                        <div class="col-12 md:col-6 lg:col-3">
                                            <label class="block font-medium mb-1">Vencimiento</label>
                                            <p-datepicker formControlName="expiration_date" class="w-full" styleClass="w-full" appendTo="body"></p-datepicker>
                                        </div>
                                        <div class="col-12 md:col-6 lg:col-3" *ngIf="isTestItem()">
                                            <label class="block font-medium mb-1">Fecha de Pedido</label>
                                            <p-datepicker formControlName="request_date" class="w-full" styleClass="w-full" appendTo="body"></p-datepicker>
                                        </div>
                                        <div class="col-12 md:col-6 lg:col-3" *ngIf="isTestItem()">
                                            <label class="block font-medium mb-1">Fecha de Recepción</label>
                                            <p-datepicker formControlName="reception_date" class="w-full" styleClass="w-full" appendTo="body"></p-datepicker>
                                        </div>
                                    </div>
                                </div>

                                <div class="surface-card p-4 border-round shadow-1" *ngIf="isTestItem()">
                                    <div class="section-header"><i class="pi pi-exclamation-triangle"></i> Clasificación Toxicológica</div>
                                    <div class="flex flex-column gap-3">
                                        <div class="w-full md:w-6">
                                            <label class="block font-medium mb-1">Clase Toxicológica</label>
                                            <p-select [options]="toxicologyClasses" formControlName="toxicology" optionLabel="label" optionValue="value" placeholder="Seleccione clase..." class="w-full" appendTo="body" [showClear]="true"></p-select>
                                        </div>
                                        <div class="surface-100 p-3 border-round text-sm text-600 flex align-items-start gap-2 border-1 border-300">
                                            <i class="pi pi-info-circle text-primary mt-1"></i>
                                            <span class="line-height-3">
                                                Los índices (o categorías) toxicológicos I, II y III forman parte de la clasificación internacional (de la OMS y EPA) utilizada para evaluar el riesgo agudo de sustancias químicas y plaguicidas. Se basan en la dosis letal media (DL50) para determinar su peligrosidad.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="surface-card p-4 border-round shadow-1">
                                    <div class="section-header"><i class="pi pi-trash"></i> Gestión Ambiental</div>
                                    <div class="flex flex-column md:flex-row gap-3">
                                        <div class="w-full md:w-6">
                                            <label class="block font-medium mb-1">Categoría Residuo Sólido</label>
                                            <p-select [options]="wasteClassOptions()" formControlName="wasteClassSolid" optionLabel="label" optionValue="value" placeholder="Seleccione categoría..." class="w-full" [showClear]="true" appendTo="body"></p-select>
                                        </div>
                                        <div class="w-full md:w-6">
                                            <label class="block font-medium mb-1">Categoría Residuo Líquido</label>
                                            <p-select [options]="wasteClassOptions()" formControlName="wasteClassLiquid" optionLabel="label" optionValue="value" placeholder="Seleccione categoría..." class="w-full" [showClear]="true" appendTo="body"></p-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="surface-card p-4 border-round shadow-1">
                                    <div class="section-header"><i class="pi pi-shield"></i> Regulaciones y Normativas</div>
                                    <div class="col-12 p-0">
                                        <label class="block font-medium mb-2 text-primary">Entes Reguladores / Normativas</label>
                                        <p-multiselect [options]="regulations()" formControlName="regulationIds" optionLabel="label" optionValue="value" placeholder="Seleccione Regulaciones..." class="w-full" display="chip" appendTo="body"></p-multiselect>
                                    </div>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- TAB BPL (AGROCHEMICALS) -->
                        <p-tabpanel [value]="8" *ngIf="isTestItem()">
                            <app-test-item-bpl-data
                                [parentForm]="form"
                                [item]="item()"
                                [formulationTypes]="formulationTypes()"
                                (onPrintPartition)="printPartition($event)">
                            </app-test-item-bpl-data>
                        </p-tabpanel>

                        <!-- TAB MOVEMENTS -->
                        <p-tabpanel [value]="4" *ngIf="item()?.id && !isTestItem()">
                            <div class="p-4">
                                <p-table [value]="itemMovements()" [loading]="loadingMovements()" styleClass="p-datatable-sm shadow-1 border-round" [rows]="10" [paginator]="true">
                                    <ng-template pTemplate="header">
                                        <tr><th>Fecha</th><th>Tipo</th><th>Cant.</th><th>Motivo</th></tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-movement>
                                        <tr>
                                            <td>{{ movement.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
                                            <td><span [class]="'badge px-2 py-1 text-xs font-bold border-round ' + (movement.type === 'IN' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700')">{{ getMovementLabel(movement.type) }}</span></td>
                                            <td [class]="movement.type === 'IN' ? 'text-green-600' : 'text-red-600'">{{ movement.type === 'OUT' ? '-' : '+' }}{{ movement.quantity }}</td>
                                            <td>{{ movement.reason || 'Sin detalles' }}</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </p-tabpanel>

                        <!-- TAB CONSUMPTIONS -->
                        <p-tabpanel [value]="11" *ngIf="item()?.id && !isTestItem()">
                            <div class="p-4">
                                <div class="flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
                                    <div>
                                        <h3 class="text-base font-bold text-900 m-0">Historial de Consumos</h3>
                                        <span class="text-xs text-500">Registro de extracciones fraccionales y descuentos por muestra o lote de análisis.</span>
                                    </div>
                                    <p-button icon="pi pi-refresh"
                                              [rounded]="true"
                                              [text]="true"
                                              size="small"
                                              (onClick)="loadItemConsumptions(item().id)"
                                              pTooltip="Actualizar consumos">
                                    </p-button>
                                </div>

                                <p-table [value]="itemConsumptions()"
                                         [loading]="loadingConsumptions()"
                                         styleClass="p-datatable-sm shadow-1 border-round"
                                         [rows]="10"
                                         [paginator]="true">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th style="width: 11rem;">Fecha</th>
                                            <th>Lote / Envase</th>
                                            <th style="width: 10rem;">Cantidad</th>
                                            <th>Vínculo / Destino</th>
                                            <th>Motivo / Ensayo</th>
                                            <th>Registrado por</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-c>
                                        <tr>
                                            <td>
                                                <span class="text-xs text-700 font-medium">{{ c.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
                                            </td>
                                            <td>
                                                <div class="flex flex-column gap-1">
                                                    @if (c.lot_number) {
                                                        <span class="text-xs font-semibold text-700"><i class="pi pi-box mr-1"></i>Lote: {{ c.lot_number }}</span>
                                                    }
                                                    @if (c.container_code) {
                                                        <span class="text-xs text-primary font-bold"><i class="pi pi-tag mr-1"></i>Envase: {{ c.container_code }}</span>
                                                    }
                                                    @if (!c.lot_number && !c.container_code) {
                                                        <span class="text-xs text-500">-</span>
                                                    }
                                                </div>
                                            </td>
                                            <td>
                                                <span class="font-bold text-red-600">-{{ c.quantity }} {{ c.unit }}</span>
                                            </td>
                                            <td>
                                                <div class="flex flex-wrap align-items-center gap-1">
                                                    @if (c.sample_code) {
                                                        <a [routerLink]="['/laboratory/sampleResults', c.sample_code]"
                                                           pTooltip="Ver resultados de muestra #{{ c.sample_code }}"
                                                           class="no-underline">
                                                            <p-tag severity="info" styleClass="text-xs cursor-pointer" icon="pi pi-external-link">
                                                                Muestra #{{ c.sample_code }}
                                                            </p-tag>
                                                        </a>
                                                    }
                                                    @if (c.analysis_batch_code) {
                                                        <p-tag severity="warn" styleClass="text-xs" icon="pi pi-list">
                                                            Lote An. {{ c.analysis_batch_code }}
                                                        </p-tag>
                                                    }
                                                    @if (!c.sample_code && !c.analysis_batch_code) {
                                                        <p-tag severity="secondary" value="Manual" styleClass="text-xs"></p-tag>
                                                    }
                                                </div>
                                            </td>
                                            <td>
                                                <span class="text-sm text-800">{{ c.reason || 'Sin motivo registrado' }}</span>
                                            </td>
                                            <td>
                                                <span class="text-xs text-600">{{ c.consumed_by_name || c.consumed_by || '-' }}</span>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="6" class="text-center p-4 text-500">
                                                <i class="pi pi-info-circle mr-2"></i>No se registran consumos para este artículo.
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </p-tabpanel>

                        <!-- TAB FILES -->
                        <p-tabpanel [value]="5" *ngIf="item()?.id">
                            <div class="p-4">
                                <app-file-attachments [referenceId]="item()?.id" folder="items" title="Documentación del Artículo"></app-file-attachments>
                            </div>
                        </p-tabpanel>

                        <!-- TAB LINKS -->
                        <p-tabpanel [value]="6" *ngIf="item()?.id && !isTestItem()">
                            <div class="p-4">
                                <div class="surface-card p-4 border-round shadow-1">
                                    <div class="section-header"><i class="pi pi-link"></i> Equipos Vinculados</div>
                                    <!-- Link UI reuse -->
                                    <div class="flex flex-column gap-2 mb-4">
                                        <div class="p-inputgroup">
                                            <p-select [options]="allEquipments()" [ngModel]="selectedEquipmentToLink()" (ngModelChange)="selectedEquipmentToLink.set($event)" [ngModelOptions]="{standalone: true}" placeholder="Buscar equipo..." [filter]="true" class="w-full" optionLabel="label" optionValue="value" appendTo="body"></p-select>
                                            <button type="button" pButton icon="pi pi-plus" (click)="linkEquipment()"></button>
                                        </div>
                                    </div>
                                    <ul class="list-none p-0 m-0">
                                        @for(eq of linkedEquipments(); track eq.id){
                                            <li class="flex align-items-center justify-content-between p-2 border-bottom-1 border-100">
                                                <span>{{ eq.brand?.name }} {{ eq.model }} ({{ eq.serial_number }})</span>
                                                <p-button icon="pi pi-trash" [text]="true" severity="danger" (onClick)="unlinkEquipment(eq.id)"></p-button>
                                            </li>
                                        }
                                    </ul>
                                </div>
                            </div>
                        </p-tabpanel>
                    </p-tabpanels>
                </p-tabs>
            </form>
        </div>

        <!-- RIGHT COLUMN: SIDEBAR INFO (TRAY) -->
        <div class="col-12 lg:col-3 bg-surface-100 p-4 overflow-auto flex flex-column gap-4 border-left-1 border-200">

            <!-- 1. Stock Status Widget -->
            <div class="surface-card p-4 border-round-xl shadow-2 border-top-3 border-primary" *ngIf="!isService() && !isTestItem()">
                <div class="flex justify-content-between align-items-center mb-3">
                    <span class="text-900 font-bold">Estado de Inventario</span>
                    <i class="pi pi-chart-bar text-primary"></i>
                </div>

                <div class="flex flex-column gap-4">
                    <!-- Meter Group Visualization -->
                    <div class="flex flex-column gap-2">
                        <div class="flex justify-content-between mb-2">
                            <span class="text-600 font-medium">Stock Físico (Total)</span>
                            <span class="font-bold text-900">{{ form.get('stock')?.value }} {{ item()?.form?.name || 'und' }}</span>
                        </div>
                        <div class="flex justify-content-between mb-2">
                            <span class="text-600 font-medium">Stock Disponible</span>
                            <span class="font-bold text-green-600">{{ (form.get('stock')?.value || 0) - (item()?.reserved_stock || 0) - (item()?.blocked_stock || 0) }} {{ item()?.form?.name || 'und' }}</span>
                        </div>
                        <div class="flex justify-content-between mb-3">
                            <span class="text-600 font-medium text-sm">Bloqueado / Cuarentena: {{ item()?.blocked_stock || 0 }} | Reservado: {{ item()?.reserved_stock || 0 }}</span>
                        </div>
                        <p-metergroup [value]="stockMeterItems()" [max]="form.get('max_stock')?.value || 100">
                            <ng-template #label let-items>
                                <div class="flex flex-column gap-2 mt-3">
                                    @for(item of items; track item.label){
                                        <div class="flex align-items-center justify-content-between">
                                            <div class="flex align-items-center gap-2">
                                                <i [class]="item.icon" [style.color]="item.color" class="text-xs"></i>
                                                <span class="text-xs font-medium text-600">{{ item.label }}</span>
                                            </div>
                                            <span class="text-xs font-bold text-900">{{ item.value }}</span>
                                        </div>
                                    }
                                </div>
                            </ng-template>
                        </p-metergroup>
                    </div>

                    <!-- Mini Cards for quick view -->
                    <div class="grid grid-nogutter gap-2">
                        <div class="col surface-50 p-2 border-round border-1 border-200 text-center">
                            <span class="block text-xs text-500 font-medium mb-1">MÍNIMO</span>
                            <span class="font-bold text-red-600">{{ form.get('min_stock')?.value || 0 }}</span>
                        </div>
                        <div class="col surface-50 p-2 border-round border-1 border-200 text-center">
                            <span class="block text-xs text-500 font-medium mb-1">ALERTA</span>
                            <span class="font-bold text-orange-600">{{ form.get('alert_stock')?.value || 0 }}</span>
                        </div>
                        <div class="col surface-50 p-2 border-round border-1 border-200 text-center">
                            <span class="block text-xs text-500 font-medium mb-1">MÁXIMO</span>
                            <span class="font-bold text-blue-600">{{ form.get('max_stock')?.value || 0 }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 1.5. Trend / Forecast Widget -->
            @if(itemForecast()) {
                <div class="surface-card p-4 border-round-xl shadow-2">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <span class="text-900 font-bold">Tendencia de Consumo</span>
                        <i class="pi pi-chart-line" [ngClass]="itemForecast()?.daysToZero && itemForecast()?.daysToZero < 30 ? 'text-red-500' : 'text-primary'"></i>
                    </div>

                    @if(itemForecast()?.avgDailyConsumption > 0) {
                        <div class="flex flex-column gap-3">
                            <div class="flex justify-content-between align-items-center border-bottom-1 border-100 pb-2">
                                <span class="text-500 text-sm">Consumo Diario Promedio</span>
                                <span class="font-bold text-900">{{ itemForecast()?.avgDailyConsumption | number:'1.0-2' }} und/día</span>
                            </div>

                            <div class="flex justify-content-between align-items-center">
                                <span class="text-500 text-sm">Agotamiento Estimado</span>
                                @if(itemForecast()?.daysToZero) {
                                    <span class="font-bold" [ngClass]="itemForecast()?.daysToZero < 30 ? 'text-red-600' : 'text-green-600'">
                                        En {{ itemForecast()?.daysToZero | number:'1.0-0' }} días
                                    </span>
                                } @else {
                                    <span class="font-bold text-500">N/A</span>
                                }
                            </div>

                            @if(itemForecast()?.dateZero) {
                                <div class="text-xs text-right text-500">
                                    Aprox. el {{ itemForecast()?.dateZero | date:'dd/MM/yyyy' }}
                                </div>
                            }
                        </div>
                    } @else {
                        <div class="text-center py-2">
                            <i class="pi pi-info-circle text-400 text-2xl mb-2"></i>
                            <p class="m-0 text-sm text-500">No hay suficientes movimientos de salida recientes para calcular una tendencia.</p>
                        </div>
                    }
                </div>
            }

            <!-- 2. QR Code & Label Widget -->
            @if(item()?.id){
                <div class="surface-card p-4 border-round-xl shadow-2 flex flex-column align-items-center gap-3">
                    <div class="text-center">
                        <span class="text-sm font-bold text-900 block mb-2">Identificación Digital</span>
                        <div class="p-2 bg-white border-round border-1 border-200 shadow-sm inline-block">
                            <img [src]="qrCodeImage()" alt="QR" class="w-full border-round" style="max-width: 120px;" *ngIf="qrCodeImage()">
                        </div>
                    </div>
                    <p-button label="Imprimir Etiqueta" icon="pi pi-print" size="small" [text]="true" (onClick)="printLabel()"></p-button>
                </div>
            }

            <!-- 3. Metadata / Audit Widget -->
            <div class="surface-card p-4 border-round-xl shadow-2 flex flex-column gap-3">
                <span class="text-sm font-bold text-900 border-bottom-1 border-100 pb-2">Datos de Auditoría</span>
                <div class="flex flex-column gap-2">
                    <div class="flex justify-content-between text-xs">
                        <span class="text-500">Creado</span>
                        <span class="text-700 font-medium">{{ item()?.createdAt | date:'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="flex justify-content-between text-xs">
                        <span class="text-500">Última mod.</span>
                        <span class="text-700 font-medium">{{ item()?.updatedAt | date:'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="flex justify-content-between text-xs">
                        <span class="text-500">Responsable</span>
                        <span class="text-700 font-medium">{{ item()?.createdBy || 'Admin' }}</span>
                    </div>
                </div>
            </div>

            <!-- Space filler -->
            <div class="mt-auto"></div>
        </div>
    </div>
</div>

<!-- Label for Printing -->
@if(item()?.id || printItemData()){
    <app-item-label
        [item]="printItemData() || item()"
        [partition]="printPartitionData()"
        [suppliers]="suppliers()"
        [locations]="locations()"
        [units]="units()">
    </app-item-label>
}

<!-- LOT CREATION / EDIT MODAL DIALOG -->
<p-dialog
    [(visible)]="lotDialogVisible"
    [header]="editingLotId() ? 'Editar Lote' : 'Alta de Nuevo Lote'"
    [modal]="true"
    [style]="{ width: '480px' }"
    [draggable]="false"
    [resizable]="false">
    <form [formGroup]="lotForm" class="flex flex-column gap-3 pt-2">
        <div class="grid">
            <div class="col-12 md:col-6">
                <label class="font-bold block mb-1">Nº Lote Fabricante <span class="text-red-500">*</span></label>
                <input pInputText formControlName="lot_number" placeholder="Ej: BCBT5432V" class="w-full" [class.p-invalid]="lotForm.get('lot_number')?.invalid && (lotForm.get('lot_number')?.dirty || lotForm.get('lot_number')?.touched)" />
                <small class="text-red-500 block mt-1" *ngIf="lotForm.get('lot_number')?.invalid && (lotForm.get('lot_number')?.dirty || lotForm.get('lot_number')?.touched)">
                    <i class="pi pi-exclamation-circle mr-1"></i> El número de lote es obligatorio.
                </small>
            </div>
            <div class="col-12 md:col-6">
                <label class="font-bold block mb-1">Nº Control Interno Lab.</label>
                <input pInputText formControlName="internal_lot_code" placeholder="Ej: CTL-2026-0045" class="w-full" />
                <small class="text-500 block">Código interno del laboratorio (opcional)</small>
            </div>
        </div>

        <div class="field mb-0" *ngIf="form.get('consumption_mode')?.value === 'FRACTIONAL' && !editingLotId()">
            <label class="font-bold block mb-1">Códigos de Frascos / Envases Individuales (Opcional)</label>
            <input pInputText formControlName="container_codes_text" placeholder="Ej: PAT-001, PAT-002 (o escanear con lector)" class="w-full" />
            <small class="text-500 block">
                Separar por coma. Si se deja vacío, se autogenerarán según la regla de numeración configurada.
            </small>
        </div>


        <div class="grid">
            <div class="col-12 md:col-6">
                <label class="font-bold block mb-1">Fecha de Ingreso <span class="text-red-500">*</span></label>
                <p-datepicker formControlName="reception_date" dateFormat="dd/mm/yy" appendTo="body" class="w-full" styleClass="w-full" [ngClass]="{'ng-invalid ng-dirty': lotForm.get('reception_date')?.invalid && (lotForm.get('reception_date')?.dirty || lotForm.get('reception_date')?.touched)}"></p-datepicker>
                <small class="text-red-500 block mt-1" *ngIf="lotForm.get('reception_date')?.invalid && (lotForm.get('reception_date')?.dirty || lotForm.get('reception_date')?.touched)">
                    <i class="pi pi-exclamation-circle mr-1"></i> La fecha de ingreso es obligatoria.
                </small>
            </div>
            <div class="col-12 md:col-6">
                <label class="font-bold block mb-1">Fecha de Vencimiento</label>
                <p-datepicker formControlName="expiration_date" dateFormat="dd/mm/yy" appendTo="body" class="w-full" styleClass="w-full" [showClear]="true"></p-datepicker>
                <small class="text-500 block">Dejar vacío si no perecedero</small>
            </div>
        </div>

        <div class="grid">
            <div class="col-12 md:col-6">
                <label class="font-bold block mb-1">Stock Actual</label>
                <p-inputNumber formControlName="current_quantity" [min]="0" class="w-full" styleClass="w-full" [disabled]="true"></p-inputNumber>
                <small class="text-500 block">Modificaciones de stock se realizan vía Ajuste de Stock.</small>
            </div>
            <div class="col-12 md:col-6">
                <label class="font-bold block mb-1">Stock Inicial</label>
                <p-inputNumber formControlName="initial_quantity" [min]="0" class="w-full" styleClass="w-full" [disabled]="true"></p-inputNumber>
            </div>
        </div>

        <div class="field mb-0">
            <label class="font-bold block mb-1">Ubicación</label>
            <p-select [options]="locations()" formControlName="locationId" optionLabel="name" optionValue="id" placeholder="Depósito / Estante..." class="w-full" appendTo="body" [filter]="true" [showClear]="true"></p-select>
        </div>

        @if(canViewPrices()){
            <div class="grid">
                <div class="col-12 md:col-6">
                    <label class="font-bold block mb-1">Costo Unitario</label>
                    <p-inputNumber formControlName="unit_price" mode="decimal" [minFractionDigits]="2" class="w-full" styleClass="w-full"></p-inputNumber>
                </div>
                <div class="col-12 md:col-6">
                    <label class="font-bold block mb-1">Moneda</label>
                    <p-select [options]="[{label: 'ARS', value: 'ARS'}, {label: 'USD', value: 'USD'}, {label: 'EUR', value: 'EUR'}]" formControlName="currency" optionLabel="label" optionValue="value" class="w-full" appendTo="body"></p-select>
                </div>
            </div>
        }

        <div class="field mb-0">
            <label class="font-bold block mb-1">Estado</label>
            <p-select [options]="[
                {label: 'Activo', value: 'ACTIVE'},
                {label: 'Agotado', value: 'DEPLETED'},
                {label: 'Vencido', value: 'EXPIRED'},
                {label: 'Bloqueado', value: 'BLOCKED'}
            ]" formControlName="status" optionLabel="label" optionValue="value" class="w-full" appendTo="body"></p-select>
        </div>

        <div class="field mb-0">
            <label class="font-bold block mb-1">Notas / Observaciones</label>
            <textarea pInputTextarea formControlName="notes" rows="2" placeholder="Detalles de recepción, proveedor, etc." class="w-full"></textarea>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <p-button label="Cancelar" [text]="true" severity="secondary" (onClick)="lotDialogVisible.set(false)" [disabled]="isSavingLot()"></p-button>
            <p-button [label]="editingLotId() ? 'Guardar Cambios' : 'Crear Lote'" icon="pi pi-check" (onClick)="saveLot()" [loading]="isSavingLot()"></p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- MODAL: REGISTRAR CONSUMO DE ENVASE (ALÍCUOTA) -->
<p-dialog [header]="'Registrar Consumo de Contenido (Alícuota)'"
          [(visible)]="showConsumeDialog"
          [modal]="true"
          [style]="{ width: '480px' }"
          appendTo="body">
    <div class="p-3">
        <div class="bg-blue-50 border-1 border-blue-200 border-round p-3 mb-3">
            <span class="text-xs text-blue-900 font-semibold block">Envase: {{ selectedContainer()?.container_code }} (Lote: {{ selectedContainer()?.lot_number || '-' }})</span>
            <span class="text-xs text-blue-700">
                Disponible para extracción: <strong>{{ selectedContainer()?.remaining_content }} {{ selectedContainer()?.content_unit || form.get('content_unit')?.value }}</strong>
            </span>
        </div>

        <form [formGroup]="consumeForm" class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
                <label for="consume_quantity" class="text-sm font-bold text-900">Cantidad a Extraer <span class="text-red-500">*</span></label>
                <p-inputNumber id="consume_quantity"
                               formControlName="quantity"
                               [min]="0.0001"
                               [max]="selectedContainer()?.remaining_content || 999999"
                               [minFractionDigits]="1"
                               [maxFractionDigits]="4"
                               [suffix]="' ' + (selectedContainer()?.content_unit || form.get('content_unit')?.value || '')"
                               class="w-full"
                               [ngClass]="{'ng-invalid ng-dirty': consumeForm.get('quantity')?.invalid && (consumeForm.get('quantity')?.dirty || consumeForm.get('quantity')?.touched)}"></p-inputNumber>
                @if ((consumeForm.get('quantity')?.dirty || consumeForm.get('quantity')?.touched) && consumeForm.get('quantity')?.invalid) {
                    <small class="text-red-500 block mt-1"><i class="pi pi-exclamation-circle mr-1"></i> Debe indicar una cantidad válida mayor a 0 y menor o igual al remanente disponible.</small>
                }
            </div>

            <div class="flex flex-column gap-1">
                <label for="consume_sample_code" class="text-sm font-bold text-900">Código de Muestra Asociada (Opcional)</label>
                <p-inputNumber id="consume_sample_code"
                               formControlName="sample_code"
                               [useGrouping]="false"
                               placeholder="Ej: 88"
                               class="w-full"></p-inputNumber>
                <small class="text-500">Si se consume para un ensayo o muestra específica, ingrese el ID numérico.</small>
            </div>

            <div class="flex flex-column gap-1">
                <label for="consume_reason" class="text-sm font-bold text-900">Motivo / Ensayo</label>
                <input id="consume_reason"
                       type="text"
                       pInputText
                       formControlName="reason"
                       placeholder="Ej: Preparación de fase móvil / Estándar analítico"
                       class="w-full" />
            </div>
        </form>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2 p-2">
            <p-button label="Cancelar" [text]="true" severity="secondary" (onClick)="showConsumeDialog.set(false)" [disabled]="isConsuming()"></p-button>
            <p-button label="Registrar Descuento"
                      icon="pi pi-check"
                      severity="warn"
                      [loading]="isConsuming()"
                      (onClick)="confirmConsume()"></p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- MODAL: HISTORIAL DE CONSUMOS DE ENVASE -->
<p-dialog [header]="'Historial de Consumos: ' + (selectedContainerForConsumptions()?.container_code || 'Envase')"
          [(visible)]="showContainerConsumptionsDialog"
          [modal]="true"
          [style]="{ width: '750px', maxWidth: '95vw' }"
          appendTo="body">
    <div class="p-3">
        <!-- Resumen del Envase -->
        <div class="surface-100 border-round p-3 mb-3 flex flex-wrap align-items-center justify-content-between gap-3 border-1 surface-border">
            <div class="flex align-items-center gap-3">
                <div class="w-3rem h-3rem border-round-xl bg-primary-50 flex align-items-center justify-content-center text-primary font-bold text-xl">
                    <i class="pi pi-box"></i>
                </div>
                <div>
                    <div class="flex align-items-center gap-2">
                        <span class="text-base font-bold text-900">{{ selectedContainerForConsumptions()?.container_code }}</span>
                        <p-tag [value]="getContainerStatusLabel(selectedContainerForConsumptions()?.status)"
                               [severity]="getContainerStatusSeverity(selectedContainerForConsumptions()?.status)">
                        </p-tag>
                    </div>
                    <span class="text-xs text-500">Lote: <strong>{{ selectedContainerForConsumptions()?.lot_number || '-' }}</strong></span>
                </div>
            </div>
            <div class="flex align-items-center gap-4 text-right">
                <div>
                    <span class="text-xs text-500 block">Contenido Inicial</span>
                    <span class="text-sm font-semibold text-700">{{ selectedContainerForConsumptions()?.initial_content || selectedContainerForConsumptions()?.nominal_content }} {{ selectedContainerForConsumptions()?.content_unit || form.get('content_unit')?.value }}</span>
                </div>
                <div>
                    <span class="text-xs text-500 block">Remanente Actual</span>
                    <span class="text-sm font-bold text-primary">{{ selectedContainerForConsumptions()?.remaining_content }} {{ selectedContainerForConsumptions()?.content_unit || form.get('content_unit')?.value }}</span>
                </div>
            </div>
        </div>

        <!-- Tabla de Consumos -->
        <p-table [value]="selectedContainerForConsumptions()?.consumptions || []"
                 responsiveLayout="scroll"
                 styleClass="p-datatable-sm p-datatable-striped">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 10rem;">Fecha</th>
                    <th style="width: 8rem;">Cantidad</th>
                    <th>Vínculo / Destino</th>
                    <th>Motivo / Ensayo</th>
                    <th>Registrado por</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-c>
                <tr>
                    <td>
                        <span class="text-xs text-700 font-medium">{{ c.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
                    </td>
                    <td>
                        <span class="font-bold text-red-600">-{{ c.quantity }} {{ c.unit || selectedContainerForConsumptions()?.content_unit || form.get('content_unit')?.value }}</span>
                    </td>
                    <td>
                        <div class="flex flex-wrap align-items-center gap-1">
                            @if (c.sample_code) {
                                <a [routerLink]="['/laboratory/sampleResults', c.sample_code]"
                                   (click)="showContainerConsumptionsDialog.set(false)"
                                   pTooltip="Ver resultados de muestra #{{ c.sample_code }}"
                                   class="no-underline">
                                    <p-tag severity="info" styleClass="text-xs cursor-pointer" icon="pi pi-external-link">
                                        Muestra #{{ c.sample_code }}
                                    </p-tag>
                                </a>
                            }
                            @if (c.analysis_batch_code) {
                                <p-tag severity="warn" styleClass="text-xs" icon="pi pi-list">
                                    Lote An. {{ c.analysis_batch_code }}
                                </p-tag>
                            }
                            @if (!c.sample_code && !c.analysis_batch_code) {
                                <p-tag severity="secondary" value="Manual" styleClass="text-xs"></p-tag>
                            }
                        </div>
                    </td>
                    <td>
                        <span class="text-sm text-800">{{ c.reason || 'Sin motivo registrado' }}</span>
                    </td>
                    <td>
                        <span class="text-xs text-600">{{ c.performedBy?.name || c.performed_by || '-' }}</span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5" class="text-center py-4 text-500 text-sm">
                        No se registran consumos para este envase aún.
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end p-2">
            <p-button label="Cerrar" [text]="true" severity="secondary" (onClick)="showContainerConsumptionsDialog.set(false)"></p-button>
        </div>
    </ng-template>
</p-dialog>
